module.exports = __webpack_public_path__ + "static/media/sn_h_insta.dc3a2290.svg";